import dayjs from "dayjs";
import api from "../../api";
import { formatDate, getVisibility, NAConverter } from "../../utils";
import { collectionSubAdapter } from "../collection/adapter";
import systemAdapter from '../system/adapter'
import subAdapter from './adapter.sub'

const adapter = {
  formToRequestBody(input){
    let output = {}

    if(input){
      const {
        title_en,
        title_id,
        event_start_date,
        event_start_time,
        event_end_date,
        event_end_time,
        about_en,
        about_id,
        province,
        city,
        address,
        pin_point,
        suitable,
        approach,
        issue,
        tags,
        gallery = [],
        submission,
        status_activity = 1,
        cancel_reason = '',
        note = null
      } = input

      output = {
        judulActivity: [title_id, title_en],
        deskripsiPendek: [NAConverter(about_id), NAConverter(about_en)],
        deskripsiPanjang: [NAConverter(about_id), NAConverter(about_en)],
        tanggalMulai: subAdapter.date_time.formToRequestBody(event_start_date, event_start_time),
        tanggalSelesai: subAdapter.date_time.formToRequestBody(event_end_date, event_end_time),
        typeAudience: suitable.map((s) => s.value),
        typeApproach: approach.map((s) => s.value),
        typeIssues: issue.map((s) => s.value),
        tag: tags.map((t) => t.value),
        typeVisibility: 1,
        typeSensitivity: 1,
        galleries: subAdapter.gallery.formToRequestBody(gallery),
        submission,
        statusActivity: status_activity,
        cancelReason: cancel_reason,
        rescheduleNote: note,

        ...subAdapter.location.formToRequestBody({province, city, address, pin_point})
      };
    }

    return output
  },
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        activityId,
        eventId,
        myOrganisasi,
        judulActivity,
        imgThumbnail,
        deskripsiPendek,
        deskripsiPanjang,
        tanggalMulai,
        tanggalSelesai,
        lokasi,
        lokasiOnline = [],
        typeApproach,
        typeAudience,
        typeIssues,
        typeActivity,
        galleries = [],
        totalLikes,
        totalBookmarks,
        submission,
        testimoniUser = [],
        testimoniNonUser = [],
        comments = [],
        listLike = [],
        listBookmark = [],
        statusActivity,
        activityOrganizing = {},
        likedByMe,
        bookmarkByMe,
        cancelReason,
        rescheduleNote,
        tag = []
      } = input

      const {
        pkActivityOrganizingId,
        urlRegistrasiEksternal,
        activityParticipantEksternal = [],
        activityParticipantInternal = [],
        // participantSeat,
        // registrationStartDate,
        registrationEndDate,
      } = activityOrganizing

      function convertTranslation(arrayOfString){
        const result = {
          en: '',
          id: ''
        }

        if(arrayOfString && arrayOfString[0] && typeof arrayOfString[0] === 'string'){
          result.en = arrayOfString[1]
          result.id = arrayOfString[0]
        }

        return result
      }

      const title = convertTranslation(judulActivity)
      const excerpt = convertTranslation(deskripsiPendek)
      const content = convertTranslation(deskripsiPanjang)
      const organization = myOrganisasi ? myOrganisasi : {}

      const is_upcoming = dayjs().isBefore(tanggalMulai)
      const is_ongoing = dayjs().isAfter(tanggalMulai) && dayjs().isBefore(tanggalSelesai)
      const is_past = dayjs().isAfter(tanggalSelesai)

      // const visibility = getVisibility(input).visibility
      const visiblity_field_blacklist = ['vsbDeskripsiPendek', 'vsbTanggalSelesai', 'vsbTypeSensitivity', 'vsbTypeVisibility', 'vsbStatusActivity', 'vsbTbActivityOrganizing', 'vsbTbLokasiOnline', 'vsbTbFase', 'vsbTbPartnerActivityInternal', 'vsbTbPartnerActivityEksternal', 'vsbTbFiles', 'vsbTag']
      const visibility_id_only = getVisibility(input, visiblity_field_blacklist).visibilityIdOnly
      const is_all_public = getVisibility(input).isAllPublic
      const is_private = getVisibility(input).isPrivate
      // const visibility_keys = getVisibility(input).visibilityKeys
      // const visibility_settings = visibility_keys?.map(v => subAdapter.visibility.responseBodyToForm(v, visibility[v]))

      const totalGuest = activityParticipantEksternal.length + activityParticipantInternal.length

      const isOffline = lokasi && lokasi.length > 0
      const isOnline = lokasiOnline && lokasiOnline.length > 0
      const isDualLocation = isOffline && isOnline

      const start_datetime = subAdapter.date_time.responseBodyToRender(tanggalMulai, 'en')
      const end_datetime = subAdapter.date_time.responseBodyToRender(tanggalSelesai, 'en')
      const start_datetime_id = subAdapter.date_time.responseBodyToRender(tanggalMulai, 'id')
      const end_datetime_id = subAdapter.date_time.responseBodyToRender(tanggalSelesai, 'id')

      let is_special = false
      if(tag.length > 0){
        for (let index = 0; index < tag.length; index++) {
          const element = tag[index];
          console.log(element)
          const {
            pilihanTagId = {}
          } = element

          if(
            pilihanTagId &&
            pilihanTagId.nama &&
            pilihanTagId.nama[0]
          ){
            const { nama = [] } = pilihanTagId
            if(
            nama[0].toLowerCase().includes('special')
            || nama[1].toLowerCase().includes('special')
            || nama[0].toLowerCase().includes('spesial')
            || nama[1].toLowerCase().includes('spesial') ){
              is_special = true
            }
          }
        }
      }

      let is_registration_closed = false

      if(dayjs().isAfter(registrationEndDate, 'day')){
        is_registration_closed = true
      } else {
        if(dayjs().isAfter(registrationEndDate, 'hour')){
          is_registration_closed = true
        } else {
          if(dayjs().isAfter(registrationEndDate, 'minute')){
            is_registration_closed = true
          } else {
            if(dayjs().isAfter(registrationEndDate, 'second')){
              is_registration_closed = true
            }
          }
        }
      }

      output = {
        id: eventId ? eventId : activityId,
        is_all_public,
        is_private,
        image: api.base_image+imgThumbnail,
        date: `${formatDate(tanggalMulai)} - ${formatDate(tanggalSelesai)}`,
        datetime: `${start_datetime} - ${end_datetime}`,
        date_short: `${dayjs(tanggalMulai).format('DD/MM/YYYY')} - ${dayjs(tanggalSelesai).format('DD/MM/YYYY')}`,
        start_date: tanggalMulai,
        start_date_formatted: formatDate(tanggalMulai),
        start_datetime,
        end_date: tanggalSelesai,
        end_date_formatted: formatDate(tanggalSelesai),
        end_datetime,
        start_end_datetime: {
          en: `${start_datetime} –<br/>${end_datetime}`,
          id: `${start_datetime_id} –<br/>${end_datetime_id}`,
        },
        start_end_datetime_pdf: {
          en: `${start_datetime} –\n${end_datetime}`,
          id: `${start_datetime_id} –\n${end_datetime_id}`,
        },
        is_registration_closed,
        is_upcoming,
        is_ongoing,
        is_past,
        is_special,
        organization_id: organization.organisasiId,
        organization: organization.namaOrganisasi,
        organization_logo: api.base_image+organization.imgLogoOrganisasi,
        title,
        excerpt,
        content,
        location: subAdapter.location.responseBodyToRender(lokasi?.[0]),
        location_online: subAdapter.location_online.responseBodyToRender(lokasiOnline?.[0]),
        location_online_rendered: subAdapter.location_online.responseBodyToString(lokasiOnline?.[0]),
        is_offline: isOffline,
        is_online: isOnline,
        is_dual_location: isDualLocation,
        featured: false,
        type: {
          en: typeActivity?.nama?.[1],
          id: typeActivity?.nama?.[0]
        },
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
        audience_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeAudience),
        gallery_images: galleries.map(g => {return {url: api.base_image+g.imgGambar}}),
        city: subAdapter.city.responseBodyToRender(lokasi),
        cities: lokasi?.length,
        status_id: statusActivity?.id,
        status: {
          en: is_upcoming ? 'upcoming' : is_ongoing ? 'ongoing' : is_past ? 'completed' : statusActivity?.nama[1],
          id: is_upcoming ? 'upcoming' : is_ongoing ? 'ongoing' : is_past ? 'completed' : statusActivity?.nama[0]
        },
        visibility: 'Public',
        unread: false,
        submission,
        total_likes: totalLikes,
        total_bookmarks: totalBookmarks,

        testimonials: testimoniUser?.map(t => subAdapter.testimonial.responseBodyToRender(t)),
        testimonials_external: testimoniNonUser?.map(t => subAdapter.testimonial_external.responseBodyToRender(t)),
        comments: comments?.map(c => subAdapter.comment.responseBodyToRender(c)),
        likes: listLike.map(l => collectionSubAdapter.like.responseBodyToRender(l)),
        bookmarks: listBookmark.map(l => collectionSubAdapter.like.responseBodyToRender(l)),

        // VISIBILITY
        // visibility,
        visibility_id_only,
        // visibility_keys,
        // visibility_settings,

        pkActivityOrganizingId,

        liked: likedByMe,
        bookmarked: bookmarkByMe,
        cancel_reason: cancelReason,
        note: rescheduleNote,
        registration_url: urlRegistrasiEksternal,
        registration_type: urlRegistrasiEksternal && urlRegistrasiEksternal !== null && urlRegistrasiEksternal !== "" ? 'external' : 'internal',

        participant_internal: activityParticipantInternal,
        participant_external: activityParticipantEksternal,
        participant_map: subAdapter.participant.responseBodyToMap(activityParticipantInternal, activityParticipantEksternal),
        guests: totalGuest,
        price: {
          en: 'Free',
          id: 'Gratis'
        },
      };
    }

    return output
  },
  sub: subAdapter
}

export default adapter
